// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedpost_feeddropdown__quxf9 {
  position: absolute;
  display: inline-block;
  height: 36px;
  right: -8px;
}
.feedpost_feeddropdownlinks__B2D9B {
  border-radius: 25px;
  display: none;
  position: absolute;
  right: -27px;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 20px 26px 10px 20px;
}
.feedpost_feeddropdown__quxf9:hover .feedpost_feeddropdownlinks__B2D9B {
  display: block;
}

.feedpost_feeddropdownbutton__6QAsv {
  outline: none;
  background-color: white;
  /* color: white; */
  padding: 8px;
  font-size: 16px;
  border: none;
  /* cursor: pointer; */
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feedpost_feeddropdownbutton__6QAsv:hover .feedpost_feeddropdownlinks__B2D9B {
  display: block;
}

.feedpost_feeddropdownlinks__B2D9B > ul {
  /* margin-bottom: 0.5rem;
      font-size: 0.8rem;
      list-style-type: none; */
  margin: 0;
  padding: 0;
}
.feedpost_feeddropdownlinks__B2D9B > ul > li {
  margin: 0px 0px 7px 0px;
  font-size: 14px;
  list-style-type: none;
}

.feedpost_feeddropdownlinks__B2D9B > ul > li img {
  margin-right: 6px;
}

.feedpost_numberoffollows__GlPwL {
  display: none;
}
.feedpost_followsicon__vdfiY {
  display: none;
}
.feedpost_childsayselection__dqmP9 {
  display: block;
}
.feedpost_askdropdown__QQ3WI {
  width: 260px;
}
.feedpost_askdropdown__QQ3WI li {
  cursor: pointer;
}
.feedpost_noOffollows__-VDSv {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 44px; */
}
.feedpost_followdisplay__-ZZGH {
  display: none;
}
.feedpost_unfollowdisplay__6LEG9 {
  display: none;
}
.feedpost_messagehidden__\\+HwEZ {
  overflow: hidden;
  margin-bottom: 5px !important;
  margin-top: 0px; 
  color: #050505 !important;
  /* font-weight: 600; */
}
.feedpost_likedisplay__FCPEH {
  display: none;
}
.feedpost_childlikedisplay__XkUG5 {
  display: none;
  height: 12px;
  width: 12px;
}
.feedpost_childUnlike__NJsZ4 > img {
  height: 12px;
  width: 12px;
}
.feedpost_nodata__oyWmg {
  position: absolute;
  top: 28%;
  left: 41%;
  font-size: 1.6rem;
}
.feedpost_profilecount__WQUfu {
  margin-bottom: 0px;
  font-size: 12px;
  color: #878585;
  font-weight: 400;
}
.feedpost_profilehovername__YM9TL {
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: 700;
}
.feedpost_profilehovercontent__VDOy0 {
  font-weight: 400;
  font-size: 12px;
  margin-top: 0.8rem;
  margin-bottom: 6px;
  line-height: 1.4;
  word-break: break-word;
}
.feedpost_profilename__0AZMu {
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  width: -moz-fit-content;
  width: fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  display: inline-flex;
}
.feedpost_profilehoverimageandcount__EOnL2 {
  display: flex;
}
.feedpost_profilehover__1bkhy {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  min-width: 400px;
  z-index: 999;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 15px;
  padding: 15px 15px 18px 15px;
  word-break: break-word;
  white-space: normal; /* Allows wrapping at word boundaries */
  box-sizing: border-box;
  height: auto;
}
.feedpost_profilehover__1bkhy::before {
  content: "";
  position: absolute;
  top: -16px;
  left: 0;
  width: 100%;
  height: 16px;
  background: transparent;
}
.feedpost_profileHoverContentContainer__ac4Ou {
  display: none;
  position: absolute;
  left: 0;
  background-color: white;
  min-width: 280px;
  z-index: 999;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 15px;
  padding: 15px;
  margin-left: 10px;
  margin-top: 40px;
}
.feedpost_avatar__766an {
  margin-right: 8px;
  border-radius: 40% !important;
  width: 50px !important;
  height: 50px !important;
}
.feedpost_avatarWrapper__J27mA {
  position: relative;
  display: inline-block;
}
.feedpost_avatardetails__ZHkmk {
  justify-content: space-between;
  display: flex;
  position: relative;
}
.feedpost_avatarDetailsMainContainer__\\+rBb0 {
  justify-content: space-between;
  display: flex;
  position: relative;
}
.feedpost_avatarDetailsContainer__WZbRA {
  justify-content: space-between;
  display: flex;
  position: relative;
  align-items: flex-start;
}

.feedpost_crown__Zm-jk {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px; /* Adjust the size of the crown icon */
  height: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.feedpost_askCrown__iHpEM {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 13px; /* Adjust the size of the crown icon */
  height: 13px;
  margin-right: -3px;
  margin-bottom: -3px;
}
.feedpost_profileUserName__e3hAU {
  font-size: 14px;
  font-weight: bold;
  color: #333; /* Adjust color */
  margin: 0;
}

.feedpost_avatarContainer__VjJoU {
  position: relative;
  align-self: flex-start;
  height: -moz-fit-content;
  height: fit-content;
}

.feedpost_avatarContainer__VjJoU:hover .feedpost_profilehover__1bkhy,
.feedpost_avatarContainer__VjJoU:hover .feedpost_profileHoverContentContainer__ac4Ou,
.feedpost_avatarDetailsContainer__WZbRA:has(.feedpost_avatarContainer__VjJoU:hover) .feedpost_profilehover__1bkhy,
.feedpost_avatarDetailsContainer__WZbRA:has(.feedpost_profilename__0AZMu:hover) .feedpost_profilehover__1bkhy,
.feedpost_profilename__0AZMu:hover ~ .feedpost_profilehover__1bkhy,
.feedpost_profilehover__1bkhy:hover,
.feedpost_profileHoverContentContainer__ac4Ou:hover {
  display: block;
}

/* Explicitly hide hover card when hovering over location, time, or date */
.feedpost_avatarDetailsContainer__WZbRA:has(.feedpost_locationandtime__5AjZb:hover) .feedpost_profilehover__1bkhy,
.feedpost_avatarDetailsContainer__WZbRA:has([class*="locationandtime"]:hover) .feedpost_profilehover__1bkhy,
.feedpost_locationandtime__5AjZb:hover ~ .feedpost_profilehover__1bkhy {
  display: none !important;
}

/* scrollable area for the dynamic followers list */
.feedpost_followersList__T8RPT {
  max-height: 60vh;        /* limits to 60% of viewport height */
  overflow-y: auto;        /* makes it scrollable */
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
  box-sizing: border-box;
  padding-right: 6px;
}

/* hide scrollbar if you prefer cleaner look */
.feedpost_followersList__T8RPT::-webkit-scrollbar {
  width: 0px;
}
.feedpost_followersList__T8RPT::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.feedpost_followersmodal__bEUbM {
  display: flex;
  align-items: flex-start;
}
.feedpost_materialdialog__YmNGa {
  padding: 10px 25px;
}
.feedpost_divider__EDEbh {
  width: 100% !important;
  margin: 10px 0px !important;
}
.feedpost_sampledialgoxtext__Im9y9 {
  margin-bottom: 0px;
  color: #878585;
  font-size: 0.8rem;
}
.feedpost_sampledialogdisplayname__bLCIs {
  margin-bottom: 0px;
  font-size: 1.1rem;
  font-weight: 400;
}
.feedpost_sampledialogvatar__7QED1 {
  border-radius: 50% !important;
  width: 50px !important;
  height: 50px !important;
  margin-right: 5px !important;
}
.feedpost_sampledialogtotalcount__BoQGm {
  font-size: 1.2rem;
}
.feedpost_sampledialogcountandcancel__4BJQb {
  display: flex;
  justify-content: space-between;
}
.feedpost_sampledialog__WBsOS {
  display: none !important;
}

.feedpost_dialogdeletebutton__4ivwg {
  position: relative;
  left: 39%;
  outline: none;
  border: none;
  background: #2e97e1;
  color: white;
  border-radius: 5px;
  padding: 0px 15px;
}

.feedpost_reportdialog__cnk\\+y {
  width: 400px;
  padding: 10px 25px 10px 25px;
  border-radius: 25px;
}

.feedpost_reportedModal__AciFn {
  background-color: #ffffff; /* Modal content background */
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  flex-wrap: wrap;
}

.feedpost_customBackdrop__Z5U0\\+ {
  background-color: rgba(0, 0, 0, 0.5); /* Backdrop color */
}

.feedpost_reporttextarea__ac2kf {
  background-color: #f3f2f0;
  outline: none;
  padding: 9px;
  border: 1px solid #707070;
  width: 100%;
  border-radius: 20px;
}
.feedpost_reportsubmitButtonContainer__3smNU {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.feedpost_reportsubmit__X47-i {
  border: none;
  outline: none;
  background-color: #4795de;
  color: white;
  border-radius: 25px;
  padding: 5px 20px;
  top: 0.6rem;
  margin-bottom: 13px;
}
@media screen and (max-width: "767px") {
  .feedpost_reportsubmit__X47-i {
    border: none;
    outline: none;
    background-color: #4795de;
    color: white;
    border-radius: 25px;
    padding: 5px 20px;
    top: 0.6rem;
    margin: auto;
    margin-bottom: 13px;
  }
}
.feedpost_offensiveorinappropriate__Lhm1Q {
  width: 15rem !important;
}
.feedpost_unrelated__val\\+c {
  width: 10rem;
}
.feedpost_duplicate__BL5Rh {
  width: 12rem;
}
.feedpost_reportheading__k1ZO7 {
  font-size: 20px;
}
.feedpost_reportoptionMainContainer__gyC4X {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
}
.feedpost_reportoption__e7Srx {
  margin-bottom: 0px;
}
.feedpost_edittextarea__o3TUm {
  display: none;
}
.feedpost_priavteinvite__UIgxn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 30px; */
}

.feedpost_followerbgcolor__yBwOx {
  color: #878585 !important;
  cursor: pointer;
  font-size: 12px;
  margin-top: 3px;
}
.feedpost_Loader__w2flt {
  margin: 0 auto !important;
  display: block !important;
}
@media all and (max-width: 767px) {
  .feedpost_feeddropdownlinks__B2D9B {
    right: 0;
  }
}
.feedpost_hashTagType__dqqzE {
  color: #878585 !important;
  margin-left: 5px;
}
.feedpost_priavteinvite__UIgxn span {
  padding-left: 10px;
  color: #373334;
  font-size: 14px;
}

.feedpost_followCountMainContainer__lVjO0 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.feedpost_followCountContainer__yCUg\\+ {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.feedpost_readCountContainer__x94kq {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 15px;
  min-width: 15px;
  border-width: 0px;
  border-radius: 30px;
  padding: 2px;
  background-color: #2168b2;
}
.feedpost_readCountContainer__x94kq p {
  color: #ffffff;
  margin: 2px;
}
.feedpost_hashTagBtn__U0Mbl {
  border-width: 0px;
  background-color: transparent;
  cursor: pointer;
  color: #007bff;
}
.feedpost_hashTagBtn__U0Mbl:hover {
  text-decoration: underline;
}
.feedpost_nameAndAvatarWrapper__i2X1o {
  display: flex;
  justify-content: space-between;
}
.feedpost_closeButton__9XiTz {
  border-width: 0px;
  outline: none !important;
  background-color: transparent;
  margin-top: -25px;
}
.feedpost_inlineRow__YYkLV {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/feedpost.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;8BAE4B;EAC5B,SAAS;EACT,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,uBAAkB;EAAlB,kBAAkB;EAClB,2BAAsB;EAAtB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,iCAAiC;EACjC,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB,EAAE,uCAAuC;EAC5D,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW,EAAE,sCAAsC;EACnD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW,EAAE,sCAAsC;EACnD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW,EAAE,iBAAiB;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;;;EAGE,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE,gBAAgB,SAAS,qCAAqC;EAC9D,gBAAgB,SAAS,wBAAwB;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC,EAAE,mBAAmB;AAC3D;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB","sourcesContent":[".feeddropdown {\r\n  position: absolute;\r\n  display: inline-block;\r\n  height: 36px;\r\n  right: -8px;\r\n}\r\n.feeddropdownlinks {\r\n  border-radius: 25px;\r\n  display: none;\r\n  position: absolute;\r\n  right: -27px;\r\n  background-color: white;\r\n  min-width: 160px;\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 1;\r\n  padding: 20px 26px 10px 20px;\r\n}\r\n.feeddropdown:hover .feeddropdownlinks {\r\n  display: block;\r\n}\r\n\r\n.feeddropdownbutton {\r\n  outline: none;\r\n  background-color: white;\r\n  /* color: white; */\r\n  padding: 8px;\r\n  font-size: 16px;\r\n  border: none;\r\n  /* cursor: pointer; */\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.feeddropdownbutton:hover .feeddropdownlinks {\r\n  display: block;\r\n}\r\n\r\n.feeddropdownlinks > ul {\r\n  /* margin-bottom: 0.5rem;\r\n      font-size: 0.8rem;\r\n      list-style-type: none; */\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.feeddropdownlinks > ul > li {\r\n  margin: 0px 0px 7px 0px;\r\n  font-size: 14px;\r\n  list-style-type: none;\r\n}\r\n\r\n.feeddropdownlinks > ul > li img {\r\n  margin-right: 6px;\r\n}\r\n\r\n.numberoffollows {\r\n  display: none;\r\n}\r\n.followsicon {\r\n  display: none;\r\n}\r\n.childsayselection {\r\n  display: block;\r\n}\r\n.askdropdown {\r\n  width: 260px;\r\n}\r\n.askdropdown li {\r\n  cursor: pointer;\r\n}\r\n.noOffollows {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* margin-right: 44px; */\r\n}\r\n.followdisplay {\r\n  display: none;\r\n}\r\n.unfollowdisplay {\r\n  display: none;\r\n}\r\n.messagehidden {\r\n  overflow: hidden;\r\n  margin-bottom: 5px !important;\r\n  margin-top: 0px; \r\n  color: #050505 !important;\r\n  /* font-weight: 600; */\r\n}\r\n.likedisplay {\r\n  display: none;\r\n}\r\n.childlikedisplay {\r\n  display: none;\r\n  height: 12px;\r\n  width: 12px;\r\n}\r\n.childUnlike > img {\r\n  height: 12px;\r\n  width: 12px;\r\n}\r\n.nodata {\r\n  position: absolute;\r\n  top: 28%;\r\n  left: 41%;\r\n  font-size: 1.6rem;\r\n}\r\n.profilecount {\r\n  margin-bottom: 0px;\r\n  font-size: 12px;\r\n  color: #878585;\r\n  font-weight: 400;\r\n}\r\n.profilehovername {\r\n  margin-bottom: 0px;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n.profilehovercontent {\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  margin-top: 0.8rem;\r\n  margin-bottom: 6px;\r\n  line-height: 1.4;\r\n  word-break: break-word;\r\n}\r\n.profilename {\r\n  margin-bottom: 0px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333;\r\n  width: fit-content;\r\n  max-width: fit-content;\r\n  display: inline-flex;\r\n}\r\n.profilehoverimageandcount {\r\n  display: flex;\r\n}\r\n.profilehover {\r\n  display: none;\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  background-color: white;\r\n  min-width: 400px;\r\n  z-index: 999;\r\n  background: #ffffff 0% 0% no-repeat padding-box;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  border-radius: 15px;\r\n  padding: 15px 15px 18px 15px;\r\n  word-break: break-word;\r\n  white-space: normal; /* Allows wrapping at word boundaries */\r\n  box-sizing: border-box;\r\n  height: auto;\r\n}\r\n.profilehover::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -16px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 16px;\r\n  background: transparent;\r\n}\r\n.profileHoverContentContainer {\r\n  display: none;\r\n  position: absolute;\r\n  left: 0;\r\n  background-color: white;\r\n  min-width: 280px;\r\n  z-index: 999;\r\n  background: #ffffff 0% 0% no-repeat padding-box;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  border-radius: 15px;\r\n  padding: 15px;\r\n  margin-left: 10px;\r\n  margin-top: 40px;\r\n}\r\n.avatar {\r\n  margin-right: 8px;\r\n  border-radius: 40% !important;\r\n  width: 50px !important;\r\n  height: 50px !important;\r\n}\r\n.avatarWrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n.avatardetails {\r\n  justify-content: space-between;\r\n  display: flex;\r\n  position: relative;\r\n}\r\n.avatarDetailsMainContainer {\r\n  justify-content: space-between;\r\n  display: flex;\r\n  position: relative;\r\n}\r\n.avatarDetailsContainer {\r\n  justify-content: space-between;\r\n  display: flex;\r\n  position: relative;\r\n  align-items: flex-start;\r\n}\r\n\r\n.crown {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 20px; /* Adjust the size of the crown icon */\r\n  height: 20px;\r\n  margin-right: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n.askCrown {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 13px; /* Adjust the size of the crown icon */\r\n  height: 13px;\r\n  margin-right: -3px;\r\n  margin-bottom: -3px;\r\n}\r\n.profileUserName {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333; /* Adjust color */\r\n  margin: 0;\r\n}\r\n\r\n.avatarContainer {\r\n  position: relative;\r\n  align-self: flex-start;\r\n  height: fit-content;\r\n}\r\n\r\n.avatarContainer:hover .profilehover,\r\n.avatarContainer:hover .profileHoverContentContainer,\r\n.avatarDetailsContainer:has(.avatarContainer:hover) .profilehover,\r\n.avatarDetailsContainer:has(.profilename:hover) .profilehover,\r\n.profilename:hover ~ .profilehover,\r\n.profilehover:hover,\r\n.profileHoverContentContainer:hover {\r\n  display: block;\r\n}\r\n\r\n/* Explicitly hide hover card when hovering over location, time, or date */\r\n.avatarDetailsContainer:has(.locationandtime:hover) .profilehover,\r\n.avatarDetailsContainer:has([class*=\"locationandtime\"]:hover) .profilehover,\r\n.locationandtime:hover ~ .profilehover {\r\n  display: none !important;\r\n}\r\n\r\n/* scrollable area for the dynamic followers list */\r\n.followersList {\r\n  max-height: 60vh;        /* limits to 60% of viewport height */\r\n  overflow-y: auto;        /* makes it scrollable */\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-top: 10px;\r\n  box-sizing: border-box;\r\n  padding-right: 6px;\r\n}\r\n\r\n/* hide scrollbar if you prefer cleaner look */\r\n.followersList::-webkit-scrollbar {\r\n  width: 0px;\r\n}\r\n.followersList::-webkit-scrollbar-thumb {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  border-radius: 3px;\r\n}\r\n.followersmodal {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n.materialdialog {\r\n  padding: 10px 25px;\r\n}\r\n.divider {\r\n  width: 100% !important;\r\n  margin: 10px 0px !important;\r\n}\r\n.sampledialgoxtext {\r\n  margin-bottom: 0px;\r\n  color: #878585;\r\n  font-size: 0.8rem;\r\n}\r\n.sampledialogdisplayname {\r\n  margin-bottom: 0px;\r\n  font-size: 1.1rem;\r\n  font-weight: 400;\r\n}\r\n.sampledialogvatar {\r\n  border-radius: 50% !important;\r\n  width: 50px !important;\r\n  height: 50px !important;\r\n  margin-right: 5px !important;\r\n}\r\n.sampledialogtotalcount {\r\n  font-size: 1.2rem;\r\n}\r\n.sampledialogcountandcancel {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.sampledialog {\r\n  display: none !important;\r\n}\r\n\r\n.dialogdeletebutton {\r\n  position: relative;\r\n  left: 39%;\r\n  outline: none;\r\n  border: none;\r\n  background: #2e97e1;\r\n  color: white;\r\n  border-radius: 5px;\r\n  padding: 0px 15px;\r\n}\r\n\r\n.reportdialog {\r\n  width: 400px;\r\n  padding: 10px 25px 10px 25px;\r\n  border-radius: 25px;\r\n}\r\n\r\n.reportedModal {\r\n  background-color: #ffffff; /* Modal content background */\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.customBackdrop {\r\n  background-color: rgba(0, 0, 0, 0.5); /* Backdrop color */\r\n}\r\n\r\n.reporttextarea {\r\n  background-color: #f3f2f0;\r\n  outline: none;\r\n  padding: 9px;\r\n  border: 1px solid #707070;\r\n  width: 100%;\r\n  border-radius: 20px;\r\n}\r\n.reportsubmitButtonContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.reportsubmit {\r\n  border: none;\r\n  outline: none;\r\n  background-color: #4795de;\r\n  color: white;\r\n  border-radius: 25px;\r\n  padding: 5px 20px;\r\n  top: 0.6rem;\r\n  margin-bottom: 13px;\r\n}\r\n@media screen and (max-width: \"767px\") {\r\n  .reportsubmit {\r\n    border: none;\r\n    outline: none;\r\n    background-color: #4795de;\r\n    color: white;\r\n    border-radius: 25px;\r\n    padding: 5px 20px;\r\n    top: 0.6rem;\r\n    margin: auto;\r\n    margin-bottom: 13px;\r\n  }\r\n}\r\n.offensiveorinappropriate {\r\n  width: 15rem !important;\r\n}\r\n.unrelated {\r\n  width: 10rem;\r\n}\r\n.duplicate {\r\n  width: 12rem;\r\n}\r\n.reportheading {\r\n  font-size: 20px;\r\n}\r\n.reportoptionMainContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n}\r\n.reportoption {\r\n  margin-bottom: 0px;\r\n}\r\n.edittextarea {\r\n  display: none;\r\n}\r\n.priavteinvite {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* margin-right: 30px; */\r\n}\r\n\r\n.followerbgcolor {\r\n  color: #878585 !important;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  margin-top: 3px;\r\n}\r\n.Loader {\r\n  margin: 0 auto !important;\r\n  display: block !important;\r\n}\r\n@media all and (max-width: 767px) {\r\n  .feeddropdownlinks {\r\n    right: 0;\r\n  }\r\n}\r\n.hashTagType {\r\n  color: #878585 !important;\r\n  margin-left: 5px;\r\n}\r\n.priavteinvite span {\r\n  padding-left: 10px;\r\n  color: #373334;\r\n  font-size: 14px;\r\n}\r\n\r\n.followCountMainContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n.followCountContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n.readCountContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 15px;\r\n  min-width: 15px;\r\n  border-width: 0px;\r\n  border-radius: 30px;\r\n  padding: 2px;\r\n  background-color: #2168b2;\r\n}\r\n.readCountContainer p {\r\n  color: #ffffff;\r\n  margin: 2px;\r\n}\r\n.hashTagBtn {\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n  color: #007bff;\r\n}\r\n.hashTagBtn:hover {\r\n  text-decoration: underline;\r\n}\r\n.nameAndAvatarWrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.closeButton {\r\n  border-width: 0px;\r\n  outline: none !important;\r\n  background-color: transparent;\r\n  margin-top: -25px;\r\n}\r\n.inlineRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  flex-wrap: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feeddropdown": `feedpost_feeddropdown__quxf9`,
	"feeddropdownlinks": `feedpost_feeddropdownlinks__B2D9B`,
	"feeddropdownbutton": `feedpost_feeddropdownbutton__6QAsv`,
	"numberoffollows": `feedpost_numberoffollows__GlPwL`,
	"followsicon": `feedpost_followsicon__vdfiY`,
	"childsayselection": `feedpost_childsayselection__dqmP9`,
	"askdropdown": `feedpost_askdropdown__QQ3WI`,
	"noOffollows": `feedpost_noOffollows__-VDSv`,
	"followdisplay": `feedpost_followdisplay__-ZZGH`,
	"unfollowdisplay": `feedpost_unfollowdisplay__6LEG9`,
	"messagehidden": `feedpost_messagehidden__+HwEZ`,
	"likedisplay": `feedpost_likedisplay__FCPEH`,
	"childlikedisplay": `feedpost_childlikedisplay__XkUG5`,
	"childUnlike": `feedpost_childUnlike__NJsZ4`,
	"nodata": `feedpost_nodata__oyWmg`,
	"profilecount": `feedpost_profilecount__WQUfu`,
	"profilehovername": `feedpost_profilehovername__YM9TL`,
	"profilehovercontent": `feedpost_profilehovercontent__VDOy0`,
	"profilename": `feedpost_profilename__0AZMu`,
	"profilehoverimageandcount": `feedpost_profilehoverimageandcount__EOnL2`,
	"profilehover": `feedpost_profilehover__1bkhy`,
	"profileHoverContentContainer": `feedpost_profileHoverContentContainer__ac4Ou`,
	"avatar": `feedpost_avatar__766an`,
	"avatarWrapper": `feedpost_avatarWrapper__J27mA`,
	"avatardetails": `feedpost_avatardetails__ZHkmk`,
	"avatarDetailsMainContainer": `feedpost_avatarDetailsMainContainer__+rBb0`,
	"avatarDetailsContainer": `feedpost_avatarDetailsContainer__WZbRA`,
	"crown": `feedpost_crown__Zm-jk`,
	"askCrown": `feedpost_askCrown__iHpEM`,
	"profileUserName": `feedpost_profileUserName__e3hAU`,
	"avatarContainer": `feedpost_avatarContainer__VjJoU`,
	"locationandtime": `feedpost_locationandtime__5AjZb`,
	"followersList": `feedpost_followersList__T8RPT`,
	"followersmodal": `feedpost_followersmodal__bEUbM`,
	"materialdialog": `feedpost_materialdialog__YmNGa`,
	"divider": `feedpost_divider__EDEbh`,
	"sampledialgoxtext": `feedpost_sampledialgoxtext__Im9y9`,
	"sampledialogdisplayname": `feedpost_sampledialogdisplayname__bLCIs`,
	"sampledialogvatar": `feedpost_sampledialogvatar__7QED1`,
	"sampledialogtotalcount": `feedpost_sampledialogtotalcount__BoQGm`,
	"sampledialogcountandcancel": `feedpost_sampledialogcountandcancel__4BJQb`,
	"sampledialog": `feedpost_sampledialog__WBsOS`,
	"dialogdeletebutton": `feedpost_dialogdeletebutton__4ivwg`,
	"reportdialog": `feedpost_reportdialog__cnk+y`,
	"reportedModal": `feedpost_reportedModal__AciFn`,
	"customBackdrop": `feedpost_customBackdrop__Z5U0+`,
	"reporttextarea": `feedpost_reporttextarea__ac2kf`,
	"reportsubmitButtonContainer": `feedpost_reportsubmitButtonContainer__3smNU`,
	"reportsubmit": `feedpost_reportsubmit__X47-i`,
	"offensiveorinappropriate": `feedpost_offensiveorinappropriate__Lhm1Q`,
	"unrelated": `feedpost_unrelated__val+c`,
	"duplicate": `feedpost_duplicate__BL5Rh`,
	"reportheading": `feedpost_reportheading__k1ZO7`,
	"reportoptionMainContainer": `feedpost_reportoptionMainContainer__gyC4X`,
	"reportoption": `feedpost_reportoption__e7Srx`,
	"edittextarea": `feedpost_edittextarea__o3TUm`,
	"priavteinvite": `feedpost_priavteinvite__UIgxn`,
	"followerbgcolor": `feedpost_followerbgcolor__yBwOx`,
	"Loader": `feedpost_Loader__w2flt`,
	"hashTagType": `feedpost_hashTagType__dqqzE`,
	"followCountMainContainer": `feedpost_followCountMainContainer__lVjO0`,
	"followCountContainer": `feedpost_followCountContainer__yCUg+`,
	"readCountContainer": `feedpost_readCountContainer__x94kq`,
	"hashTagBtn": `feedpost_hashTagBtn__U0Mbl`,
	"nameAndAvatarWrapper": `feedpost_nameAndAvatarWrapper__i2X1o`,
	"closeButton": `feedpost_closeButton__9XiTz`,
	"inlineRow": `feedpost_inlineRow__YYkLV`
};
export default ___CSS_LOADER_EXPORT___;
